// extracted by mini-css-extract-plugin
export default {"otp":"index_otp__yuaBM","signpreview":"index_signpreview__+w3Lt"};